import { makeStyles } from 'tss-react/mui';
import { ProductCardsBlockVariant } from '../../productCardsBlock.types';

const FOCUS_OUTLINE_WIDTH = 2;

const focusRadiusByVariant = {
  card: 'borderRadiusLg',
  row: 'borderRadiusXl',
} as const satisfies Record<ProductCardsBlockVariant, string>;

interface ProductCardsHeadingStylesParams {
  variant: ProductCardsBlockVariant;
}

export const useProductCardsHeadingStyles = makeStyles<ProductCardsHeadingStylesParams>()(
  (theme, { variant }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.25),
      minWidth: 0,
    },
    openButton: {
      all: 'unset',
      display: 'block',
      minWidth: 0,
      cursor: 'pointer',
      '&::after': {
        content: '""',
        position: 'absolute',
        inset: 0,
      },
      '&:focus-visible::after': {
        outline: `${FOCUS_OUTLINE_WIDTH}px solid ${theme.palette.primary.main}`,
        outlineOffset: -FOCUS_OUTLINE_WIDTH,
        borderRadius: theme.shape[focusRadiusByVariant[variant]],
      },
    },
    name: {
      color: theme.palette.text.primary,
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
    },
  }),
);
